<script>
import Tag from '@zoom/zoom-ui/src/components/tag/tag.vue';

export default {
  extends: Tag,
  methods: {
    renderContent() {
      return (
        <span
          class={this.getTagClass()}
          tabindex={this.isGroup ? '0' : '-1'} // https://zoomvideo.atlassian.net/browse/ZOOM-749150
          escape-dialog-trapped-focus={true}
          style={this.getTagStyl()}>
            {this.avatar
              ? (<span class="zm-tag__avatar">
                {this.avatar.length === 1 ? this.avatar : <img src={this.avatar} alt="User Avatar"/>}
              </span>) : ''
            }
          <span class="zm-tag__label">{this.$slots.default}</span>
          {
            this.closable
              ? <zm-button
                class="zm-tag__close"
                ghost
                size="mini"
                icon="zm-icon-close"
                tabindex='0' // https://zoomvideo.atlassian.net/browse/ZOOM-749150
                aria-label={this.deleteText}
                on-click={($event) => this.handleClose($event)}/> : ''
          }
          </span>
      );
    },
  }
};
</script>
